<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <div>
      <v-data-table
        :headers="headers"
        :items="villages"
        :options.sync="options"
        :server-items-length="totalVillages"
        :loading="loading"
        loading-text="Loading... Please wait"
        :item-class="rowClass"
        class="d-print-table"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 25, 50],
          // showFirstLastPage: true,
        }"
        sort-by="id_kab"
        :style="{ padding: '10px' }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Kelurahan</v-toolbar-title>
            <v-divider class="mx-4" inset vertical />
            <v-spacer />
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  @click="getData"
                  :loading="loading"
                  :disabled="loading"
                  ><v-icon>mdi-restart</v-icon
                  ><template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  :style="{ 'margin-right': '10px' }"
                  v-on="on"
                >
                  New Village
                </v-btn>
              </template>
              <v-card>
                <v-form>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-autocomplete
                            clearable
                            v-model="editedItem.provinsi"
                            :items="itemsProvinsi"
                            item-text="nama"
                            return-object
                            :error-messages="provinsiErrors"
                            label="Provinsi"
                            @change="$v.editedItem.provinsi.$touch()"
                            @blur="$v.editedItem.provinsi.$touch()"
                            :loading="isLoadingProvinsi"
                            :search-input.sync="searchProvinsi"
                            hide-selected
                            :disabled="view"
                          />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-autocomplete
                            clearable
                            v-model="editedItem.kabupaten"
                            :items="itemsKabupaten"
                            item-text="nama"
                            return-object
                            :error-messages="kabupatenErrors"
                            label="Kabupaten / kota"
                            @change="$v.editedItem.kabupaten.$touch()"
                            @blur="$v.editedItem.kabupaten.$touch()"
                            :loading="isLoadingKabupaten"
                            :search-input.sync="searchKabupaten"
                            :disabled="editedItem.provinsi == null || view"
                            hide-selected
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-autocomplete
                            clearable
                            v-model="editedItem.kecamatan"
                            :items="itemsKecamatan"
                            item-text="nama"
                            return-object
                            :error-messages="kecamatanErrors"
                            label="Kecamatan"
                            @change="$v.editedItem.kecamatan.$touch()"
                            @blur="$v.editedItem.kecamatan.$touch()"
                            :loading="isLoadingKecamatan"
                            :search-input.sync="searchKecamatan"
                            :disabled="editedItem.kabupaten == null || view"
                            hide-selected
                          />
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-text-field
                            v-model="editedItem.id_kel"
                            label="Kode Kelurahan"
                            :disabled="view"
                            :error-messages="idKelErrors"
                            @change="$v.editedItem.id_kel.$touch()"
                            @blur="$v.editedItem.id_kel.$touch()"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            v-model="editedItem.nama_kel"
                            label="Nama Kelurahan"
                            :error-messages="namaKabErrors"
                            @change="$v.editedItem.nama_kel.$touch()"
                            @blur="$v.editedItem.nama_kel.$touch()"
                            :disabled="view"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" text @click="close">
                      Cancel
                    </v-btn>
                    <v-btn
                      v-if="!view"
                      color="blue darken-1"
                      text
                      :loading="loading"
                      :disabled="loading"
                      @click="save"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="headline"
                  >Are you sure you want to delete this item?</v-card-title
                >
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="closeDelete"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                    >OK</v-btn
                  >
                  <v-spacer />
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
          <v-card :style="{ margin: '10px' }">
            <v-card-actions
              :style="{
                'padding-bottom': '0px',
                'padding-top': '0px',
              }"
            >
              <v-btn color="orange lighten-2" text> Search Criteria </v-btn>

              <v-switch color="primary" value v-model="show" />
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show">
                <v-divider />

                <v-container
                  :style="{
                    'padding-bottom': '0px',
                    'padding-top': '0px',
                  }"
                >
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="search.nama_kab"
                        type="text"
                        label="Nama Kota/Kabupaten"
                        v-on:keyup.enter="getData"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="search.nama_kec"
                        type="text"
                        label="Nama Kecamatan"
                        v-on:keyup.enter="getData"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="search.nama_kel"
                        type="text"
                        label="Nama Kelurahan"
                        v-on:keyup.enter="getData"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-btn
                        color="success"
                        class="mb-2 ml-2 mr-2"
                        @click="getData"
                        ><v-icon>mdi-magnify</v-icon></v-btn
                      >
                      <v-btn
                        color="warning"
                        class="mb-2 ml-2 mr-2"
                        @click="clearSearch"
                        ><v-icon>mdi-broom</v-icon></v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-expand-transition>
          </v-card>
        </template>
        <template v-slot:item="{ item, index }">
          <tr :key="index" :style="{ cursor: 'pointer' }">
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.id_prov }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.nama_kab }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.nama_kec }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              {{ item.nama_kel }}
            </td>
            <td class="d-block d-sm-table-cell d-print-table-cell">
              <v-icon small class="mr-2" @click="viewItem(item)">
                mdi-eye
              </v-icon>
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="getData"> Reset </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-card>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, numeric } from 'vuelidate/lib/validators';
import { date } from '../../lib/helpers';

export default {
  mixins: [validationMixin],
  validations: {
    editedItem: {
      nama_kel: { required },
      kecamatan: {
        required,
      },
      provinsi: {
        required,
      },
      kabupaten: {
        required,
      },
      id_kel: {
        required,
        numeric,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.id_kel == null ||
              this.errorValidation.id_kel.length < 1)
          );
        },
      },
    },
  },
  data: () => ({
    search: {
      id_kel: '',
      nama_kel: '',
      nama_kec: '',
      nama_prov: '',
      nama_kab: '',
    },
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: 'Kode Provinsi', value: 'id_prov' },
      { text: 'Nama Kota/Kabupaten', value: 'nama_kab' },
      { text: 'Nama Kecamatan', value: 'nama_kec' },
      { text: 'Nama Kelurahan', value: 'nama_kel' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      id: '',
      id_kel: '',
      nama_kel: '',
      kecamatan: null,
      kabupaten: null,
      provinsi: null,
    },
    defaultItem: {
      id: '',
      id_kel: '',
      nama_kel: '',
      kecamatan: null,
      kabupaten: null,
      provinsi: null,
    },
    searchProvinsi: '',
    searchKabupaten: '',
    searchKecamatan: '',
    isLoadingKecamatan: false,
    isLoadingKabupaten: false,
    isLoadingProvinsi: false,
  }),

  computed: {
    formTitle() {
      let item = '';
      if (this.editedIndex != -1) {
        if (this.editedIndex == -2) {
          item = 'View Item';
        } else item = 'Edit Item';
      } else item = 'New Item';
      return item;
    },
    flashErrorMessage() {
      return this.$store.state.master.daerah.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.master.daerah.flashError;
      },
      set() {
        this.$store.commit('master/daerah/setFlashErrorMessage', '');
      },
    },

    itemsKecamatan() {
      return this.$store.state.master.daerah.list.kecamatan;
    },
    itemsProvinsi() {
      return this.$store.state.master.daerah.list.provinsi;
    },
    itemsKabupaten() {
      return this.$store.state.master.daerah.list.kabupaten;
    },
    itemsKelurahan() {
      return this.$store.state.master.daerah.list.kelurahan;
    },

    errorValidation() {
      return this.$store.state.master.daerah.errors;
    },
    loading() {
      return this.$store.state.master.daerah.loading;
    },
    villages() {
      return this.$store.state.master.daerah.kelurahan;
    },
    totalVillages() {
      return this.$store.state.master.daerah.totalKelurahan;
    },

    provinsiErrors() {
      const errors = [];
      if (!this.$v.editedItem.provinsi.$dirty) return errors;
      if (!this.$v.editedItem.provinsi.required)
        errors.push('Provinsi is required');
      return errors;
    },
    kabupatenErrors() {
      const errors = [];
      if (!this.$v.editedItem.kabupaten.$dirty) return errors;
      if (!this.$v.editedItem.kabupaten.required)
        errors.push('Kabupaten is required');
      return errors;
    },
    kecamatanErrors() {
      const errors = [];
      if (!this.$v.editedItem.kecamatan.$dirty) return errors;
      if (!this.$v.editedItem.kecamatan.required)
        errors.push('Kecamatan is required');
      return errors;
    },
    namaKabErrors() {
      const errors = [];
      if (!this.$v.editedItem.nama_kel.$dirty) return errors;
      if (!this.$v.editedItem.nama_kel.required)
        errors.push('Nama Kelurahan is required');
      return errors;
    },
    idKelErrors() {
      const errors = [];
      if (!this.$v.editedItem.id_kel.$dirty) return errors;
      if (!this.$v.editedItem.id_kel.required)
        errors.push('Kode Kelurahan is required');
      if (!this.$v.editedItem.id_kel.numeric) errors.push('Must be numeric');
      if (!this.$v.editedItem.id_kel.isUnique) {
        if (this.errorValidation.id_kel != null) {
          this.errorValidation.id_kel.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
  },

  watch: {
    'editedItem.provinsi': {
      handler() {
        if (this.editedItem.provinsi == null) {
          this.editedItem.kabupaten = null;
          this.editedItem.kecamatan = null;
          this.editedItem.kelurahan = null;
        } else {
          this.getKabupaten();
        }
      },
      deep: true,
    },
    'editedItem.kabupaten': {
      handler() {
        if (this.editedItem.kabupaten == null) {
          this.editedItem.kecamatan = null;
          this.editedItem.kelurahan = null;
        } else {
          this.getKecamatan();
        }
      },
      deep: true,
    },
    'editedItem.kecamatan': {
      handler() {
        if (this.editedItem.kecamatan == null) {
          this.editedItem.kelurahan = null;
        }
      },
      deep: true,
    },
    dialog(val) {
      if (!val) this.close();
    },
    dialogDelete(val) {
      if (!val) this.closeDelete();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    show() {
      if (!this.show) {
        this.search.nama_kab = '';
        this.search.nama_kel = '';
        this.search.kecamatan = '';
        this.$nextTick(() => {
          this.getData();
        });
      }
    },
  },

  async mounted() {
    this.getData();
    this.getProvinsi();
  },

  methods: {
    async getProvinsi() {
      this.isLoadingProvinsi = true;
      await this.$store.dispatch('master/daerah/list/fetchDaerah', {
        date,
        id: 0,
        searchName: this.searchProvinsi,
        category: 'provinsi',
      });
      this.isLoadingProvinsi = false;
    },
    async getKabupaten() {
      this.isLoadingKabupaten = true;
      await this.$store.dispatch('master/daerah/list/fetchDaerah', {
        date,
        id: this.editedItem.provinsi.id_prov,
        searchName: this.searchKabupaten,
        category: 'kabupaten',
      });
      this.isLoadingKabupaten = false;
    },
    async getKecamatan() {
      this.isLoadingKecamatan = true;
      await this.$store.dispatch('master/daerah/list/fetchDaerah', {
        date,
        id: this.editedItem.kabupaten.id_kab,
        searchName: this.searchKecamatan,
        category: 'kecamatan',
      });
      this.isLoadingKecamatan = false;
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.nama_kab = '';
      this.search.nama_kel = '';
      this.search.nama_kec = '';
    },

    getData() {
      this.$store.commit('master/daerah/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch('master/daerah/fetchAllDaerah', {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        category: 'kelurahan',
      });
    },

    viewItem(item) {
      const newItem = {
        ...item,
        kecamatan: { id_kec: item.id_kec, nama: item.nama_kec },
        kabupaten: { id_kab: item.id_kab, nama: item.nama_kab },
        provinsi: { id_prov: item.id_prov, nama: item.nama_prov },
      };
      this.editedIndex =
        this.$store.state.master.daerah.kelurahan.indexOf(item);
      this.editedItem = { ...newItem };
      this.view = true;
      this.editedIndex = -2;
      this.dialog = true;
    },

    editItem(item) {
      const newItem = {
        ...item,
        id: item.id_kel,
        kecamatan: { id_kec: item.id_kec, nama: item.nama_kec },
        kabupaten: { id_kab: item.id_kab, nama: item.nama_kab },
        provinsi: { id_prov: item.id_prov, nama: item.nama_prov },
      };
      this.view = false;
      this.editedIndex =
        this.$store.state.master.daerah.kelurahan.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex =
        this.$store.state.master.daerah.kelurahan.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await this.$store
        .dispatch('master/daerah/deleteDaerah', {
          date,
          payload: this.editedItem,
          index: this.editedItem.id_kel,
          category: 'kelurahan',
        })
        .then(() => {
          this.closeDelete();
        });
    },

    close() {
      this.resetUniqueValidation();
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    closeFlash() {
      this.$store.commit('master/daerah/setFlashErrorMessage', '');
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    checkVillage(item) {
      return item.id == this.editedItem.village.id;
    },

    resetUniqueValidation() {
      this.$store.commit('master/daerah/clearErrors');
    },

    async save() {
      this.$store.commit('master/daerah/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const kelurahan = this.editedItem;
        if (this.editedIndex > -1) {
          await this.$store
            .dispatch('master/daerah/updateDaerah', {
              date,
              payload: kelurahan,
              index: this.editedIndex,
              category: 'kelurahan',
            })
            .then(() => {
              this.close();
            });
        } else {
          await this.$store
            .dispatch('master/daerah/createDaerah', {
              date,
              payload: kelurahan,
              category: 'kelurahan',
            })
            .then(() => {
              this.close();
            });
        }
      }
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
</style>
